import { render } from "./ServerZone.vue?vue&type=template&id=64e88e51"
import script from "./ServerZone.vue?vue&type=script&lang=ts"
export * from "./ServerZone.vue?vue&type=script&lang=ts"
script.render = render

export default script